import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉#，需要路由模式改为history
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/components/index.vue'], resolve),
      meta: { title: "极狮", keepAlive: true }
    },
  {//新闻
    path: '/info',
    name: 'info',
    component: resolve => require(['@/components/pc/info.vue'], resolve),
    meta: { title: "资讯详情", keepAlive: false }
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js